import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Home from "../assets/icons/footerIcons/home.svg";
import Loyalty from "../assets/icons/footerIcons/loyalty.svg";
import Rate from "../assets/icons/footerIcons/rate.svg";
import profile from "../assets/icons/footerIcons/profile.svg";
import CartIcon from "../assets/icons/sidebarIcons/cart.svg";
import { UserContext } from "../pages/UserContext"; // Ensure UserContext provides user info

const FooterNavbar = () => {
  const { user,cartUpdated  } = useContext(UserContext);
  const [cartCount, setCartCount] = useState(0);

  // Function to fetch cart data
  const fetchCartItems = async () => {
    if (!user?.id) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/cart/${user.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();

//      const data = await response.json();

      if (response.ok) {
        setCartCount(data.length); // Update cart count
      } else {
        console.error("Failed to fetch cart data:", data.message);
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  // Fetch cart count on component mount and listen for changes
  useEffect(() => {
    fetchCartItems();

    // Set up an interval to check for cart updates every few seconds
    // const interval = setInterval(() => {
    //   fetchCartItems();
    // }, 5000); // Fetch cart updates every 5 seconds

   // return () => clearInterval(interval); // Cleanup interval on unmount
  }, [user?.id, cartUpdated]); 

  return (
    <nav className="fixed bottom-0 w-full bg-white border-t border-gray-300">
      <div className="flex justify-around items-center py-2 relative">
        {/* Home */}
        <div className="flex flex-col items-center">
          <Link to="/" className="flex flex-col items-center justify-center">
            <img src={Home} className="h-5 mb-0 w-8 mb-2 text-gray-700" />
            <span className="text-sm text-gray-700">Home</span>
          </Link>
        </div>

        {/* Rate */}
        <div className="flex flex-col items-center">
          <Link to="/rate" className="flex flex-col items-center justify-center">
            <img src={Rate} className="h-5 mb-0 w-8 mb-2 text-gray-700" />
            <span className="text-sm text-gray-700">Rate</span>
          </Link>
        </div>

        {/* Loyalty */}
        <div className="flex flex-col items-center">
          <Link to="/loyalty" className="flex flex-col items-center justify-center">
            <img src={Loyalty} className="h-5 mb-0 w-8 mb-2 text-gray-700" />
            <span className="text-sm text-gray-700">Loyalty</span>
          </Link>
        </div>

        {/* Cart */}
        <div className="flex flex-col items-center relative">
          <Link to="/cart" className="flex flex-col items-center justify-center">
            {/* Cart count badge */}
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-1">
                {cartCount}
              </span>
            )}
            <img src={CartIcon} className="h-7 w-8 text-gray-700 pb-1" />
            <span className="text-sm text-gray-700">Cart</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default FooterNavbar;
